var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmployeeCardHaikei3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#140021"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 0L400 0L400 86L436 86L436 171L519 171L519 257L339 257L339 343L368 343L368 429L473 429L473 514L502 514L502 600L0 600L0 514L0 514L0 429L0 429L0 343L0 343L0 257L0 257L0 171L0 171L0 86L0 86L0 0L0 0Z",
    fill: "#9900ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M321 0L352 0L352 86L313 86L313 171L305 171L305 257L244 257L244 343L316 343L316 429L234 429L234 514L300 514L300 600L0 600L0 514L0 514L0 429L0 429L0 343L0 343L0 257L0 257L0 171L0 171L0 86L0 86L0 0L0 0Z",
    fill: "#7700c6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218 0L126 0L126 86L96 86L96 171L208 171L208 257L197 257L197 343L213 343L213 429L218 429L218 514L172 514L172 600L0 600L0 514L0 514L0 429L0 429L0 343L0 343L0 257L0 257L0 171L0 171L0 86L0 86L0 0L0 0Z",
    fill: "#560090"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployeeCardHaikei3);
export default __webpack_public_path__ + "static/media/employee-card-haikei-3.32c2de593e921d9bf484d00bb9f302b6.svg";
export { ForwardRef as ReactComponent };